import * as d3 from 'd3';
import type { SizedNode } from '../../types';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import type { HierarchyNodeA11yProps } from '../useHierarchyNavigation';

/* The stroke is set here rather than inline beside the fill, which is the only reason the focus
   ring below works: an inline `style` beats a stylesheet rule whatever its specificity, so a
   circle carrying its own `stroke` could not be given another one on focus. The fill varies per
   node and stays inline; the stroke never did.

   `outline` rather than a stroke would be the ordinary answer, but SVG shapes do not take one
   consistently across engines, and a circle certainly has a stroke. */
const NodeElement = styled.circle`
  stroke: ${colors.borderSubtle};

  &:focus-visible {
    outline: none;
    stroke: ${colors.borderFocus};
    stroke-width: 2;
  }
`;

type HierarchicalPackingViewNodeProperties = {
  node: d3.HierarchyCircularNode<SizedNode>;
  /** Role, name and the roving `tabIndex`, from the one place that knows the whole tree. */
  a11yProps: HierarchyNodeA11yProps;
};

const HierarchicalPackingViewNode = (
  props: HierarchicalPackingViewNodeProperties
) => {
  const {
    x,
    y,
    r,
    data: { modelId, color },
  } = props.node;
  return (
    <NodeElement
      cx={x}
      cy={y}
      r={r}
      style={{ fill: color ?? colors.surfaceDefault }}
      className="component"
      data-component-id={modelId ?? undefined}
      {...props.a11yProps}
    />
  );
};

export { HierarchicalPackingViewNode };
